import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { StoreButtons } from "@/components/site/StoreButtons";
import { Reveal } from "@/components/site/Reveal";
import { FeatureIcon } from "@/components/site/FeatureIcon";
import { Check, Crown } from "lucide-react";

export default function Premium() {
  const [page, setPage] = useState({ title: "", body: "" });
  const [features, setFeatures] = useState([]);

  useEffect(() => {
    api.get("/pages/premium").then(({ data }) => setPage(data)).catch(() => {});
    api.get("/premium-features").then(({ data }) => setFeatures(data)).catch(() => {});
  }, []);

  return (
    <>
      <section className="relative bg-[#0A1A10] sr-grain pt-36 pb-24 overflow-hidden">
        <div className="relative max-w-7xl mx-auto px-5 sm:px-8 text-center">
          <Reveal>
            <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#D4AF37]/30 bg-white/5">
              <Crown className="h-4 w-4 text-[#D4AF37]" />
              <span className="font-mono-accent text-xs uppercase tracking-widest text-white/80">Premium Üyelik</span>
            </span>
            <h1 className="font-serif-display text-white text-4xl sm:text-6xl font-bold mt-7 leading-tight">
              {page.title || "Saklı Rota Premium"}
            </h1>
          </Reveal>
          <Reveal delay={0.1}>
            <div
              className="rich-content mt-6 max-w-2xl mx-auto text-white/70 [&_p]:!text-white/70"
              dangerouslySetInnerHTML={{ __html: page.body || "" }}
            />
          </Reveal>
        </div>
      </section>

      <section className="bg-[#F8F9FA] py-24" data-testid="premium-features-section">
        <div className="max-w-7xl mx-auto px-5 sm:px-8">
          <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {features.map((f, i) => (
              <Reveal key={f.id} delay={(i % 3) * 0.08}>
                <div data-testid={`premium-feature-${i}`} className="h-full rounded-3xl bg-white border border-[#E2E8E4] p-8 hover:shadow-xl hover:shadow-[#0F2F1D]/10 hover:-translate-y-1 transition-all duration-500">
                  <div className="grid place-items-center h-14 w-14 rounded-2xl bg-[#1B4D2E] text-[#D4AF37] mb-6">
                    <FeatureIcon name={f.icon} className="h-7 w-7" />
                  </div>
                  <h3 className="font-serif-display text-2xl font-semibold text-[#1A251E]">{f.title}</h3>
                  <p className="mt-3 text-[#5C6F62] leading-relaxed">{f.description}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing */}
      <section className="bg-white py-24">
        <div className="max-w-4xl mx-auto px-5 sm:px-8 grid gap-6 sm:grid-cols-2">
          {[
            { name: "Aylık", price: "₺49,99", per: "/ ay", pop: false },
            { name: "Yıllık", price: "₺399,99", per: "/ yıl", pop: true, note: "%33 Tasarruf" },
          ].map((p) => (
            <Reveal key={p.name}>
              <div className={`relative h-full rounded-3xl p-8 border ${p.pop ? "bg-[#0F2F1D] border-[#D4AF37]/40 text-white" : "bg-[#F8F9FA] border-[#E2E8E4]"}`}>
                {p.pop && <span className="absolute -top-3 right-8 font-mono-accent text-[11px] uppercase tracking-wider px-3 py-1 rounded-full bg-[#D4AF37] text-[#0F2F1D]">{p.note}</span>}
                <h3 className={`font-serif-display text-2xl font-semibold ${p.pop ? "text-white" : "text-[#1A251E]"}`}>{p.name}</h3>
                <div className="mt-4 flex items-end gap-1">
                  <span className="font-serif-display text-4xl font-bold">{p.price}</span>
                  <span className={`mb-1 ${p.pop ? "text-white/60" : "text-[#5C6F62]"}`}>{p.per}</span>
                </div>
                <ul className={`mt-6 space-y-3 text-sm ${p.pop ? "text-white/80" : "text-[#5C6F62]"}`}>
                  {features.slice(0, 4).map((f) => (
                    <li key={f.id} className="flex items-center gap-2.5">
                      <Check className={`h-4 w-4 ${p.pop ? "text-[#D4AF37]" : "text-[#40916C]"}`} /> {f.title}
                    </li>
                  ))}
                </ul>
                <div className="mt-8"><StoreButtons /></div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}
